var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFileChartLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 4.66634H8.66667V11.333H7.33333V4.66634ZM10 7.33301H11.3333V11.333H10V7.33301ZM4.66667 8.66634H6V11.333H4.66667V8.66634ZM10 2.66634H3.33333V13.333H12.6667V5.33301H10V2.66634ZM2 1.99421C2 1.62904 2.29833 1.33301 2.66567 1.33301H10.6667L13.9998 4.66634L14 13.9947C14 14.3656 13.7034 14.6663 13.3377 14.6663H2.66227C2.29651 14.6663 2 14.3628 2 14.0051V1.99421Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileChartLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-chart-line.aad34e54.svg";
export { ForwardRef as ReactComponent };